export default __webpack_public_path__ + "static/media/2441.81d0d9c0.png";